import { ComponentPropsWithRef, memo } from 'react'
import { LinkProps, Link as RouterLink } from 'react-router'

import { cn } from '@/shared/lib/cn'

interface LinkOverlayProps extends ComponentPropsWithRef<'a'>, LinkProps {}

export const LinkOverlay = memo(
	({ ref, className, ...props }: LinkOverlayProps) => {
		return (
			<RouterLink
				{...props}
				ref={ref}
				className={cn(
					'wwt-linkbox__overlay',
					"before:cursor-inherit static before:absolute before:top-0 before:left-0 before:z-0 before:block before:h-full before:w-full before:content-['']",
					className
				)}
			/>
		)
	}
)

LinkOverlay.displayName = 'LinkOverlay'
